import SliderImg from './slider-img';
export default SliderImg;
